module.exports = __webpack_public_path__ + "static/media/RobotoMono-ExtraLight.642c61c3.ttf";